module.exports = __webpack_public_path__ + "img/ms.ca02fb59.svg";